<template>
  <div id="app">
    <!-- <keep-alive :include='cashViews'>
      <router-view></router-view>
    </keep-alive> -->
    <keep-alive >
      <router-view class="router-view" v-if="$route.meta.keepAlive" ></router-view>
    </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
   
  </div>
</template>

<script>
export default {
  name: 'App',
  // data(){
  //   return {
  //     // 要缓存的组件
  //       cashViews: ['alluser']
  //   }
  // },
  created(){
    // console.log(">>>>>>>"+this.$route.meta)
    // console.log(">>>>>>>"+this.$route.meta.title)
    
  },
}
</script>

<style lang="scss">
  @import "style/reset";
  @import "style/base";
</style>



// WEBPACK FOOTER //
// src/App.vue